/**
 * Lumistelle Carousel Animations Module
 * Version 2.0 - With Scroll & Hover Effects
 * Provides smooth animations, transitions, and interaction feedback.
 */
console.log('[LumistelleCarousel] Animations file loaded');

(function(window, document) {
  'use strict';

  const LumistelleGlobalUI = {
    init() {
      this.detectTouch();
    },
    detectTouch() {
      const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      if (isTouch) {
        document.body.classList.add('has-touch');
      } else {
        document.body.classList.add('no-touch');
      }
    }
  };
  LumistelleGlobalUI.init();

  const LumistelleCarouselAnimations = {
    observers: new Map(),

    // ======================================================================
    // INITIALIZATION
    // ======================================================================
    initialize(instance) {
      if (!instance || !instance.element) return;
      this.engine = instance.engine;
      this.animationStyle = instance.config.onViewAnimationStyle; // Store the chosen style

      // Only setup scroll animations if a style is selected
      if (this.animationStyle && this.animationStyle !== 'none') {
        this.setupScrollAnimations(instance);
      }

      this.setupHoverEffects(instance);
      this.setupReducedMotion();
    },

    // ======================================================================
    // SCROLL ANIMATIONS
    // ======================================================================
    setupScrollAnimations(instance) {
      // PHASE 4: Check if engine has registerObserver method
      const engine = window.Lumistelle?.engine;
      const observerKey = `scroll-animation-${instance.id}`;
      
      // PHASE 4: Prevent duplicate observer setup
      if (engine && engine.observers && engine.observers.has(observerKey)) {
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          let batchIndex = 0;
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.animateIn(entry.target, batchIndex++);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
      );
      
      // PHASE 4: Use engine's registry if available, fallback to local
      if (engine && typeof engine.registerObserver === 'function') {
        engine.registerObserver(observerKey, observer, 'scroll-animation', instance.id);
      } else {
        // Fallback to local storage
        this.observers.set(instance.id, observer);
      }

      // Observe all products within this carousel instance
      const products = instance.element.querySelectorAll('.lumistelle-carousel__product');
      products.forEach(product => {
        product.classList.add('lumistelle-carousel--animate-in');
        observer.observe(product);
      });
    },

    animateIn(element, batchIndex) {
      const delay = Math.min(batchIndex || 0, 6) * 50;
      element.style.transitionDelay = delay ? `${delay}ms` : '';
      element.classList.add('is-visible');

      // Clear inline transitionDelay after animation completes to reduce style recalc overhead
      const cleanup = () => { element.style.transitionDelay = ''; };
      element.addEventListener('transitionend', cleanup, { once: true });
      element.addEventListener('animationend', cleanup, { once: true });
    },

    observeNewProducts(instance, newProducts) {
      // PHASE 4: Try engine registry first, fallback to local
      const engine = window.Lumistelle?.engine;
      const observerKey = `scroll-animation-${instance.id}`;
      
      let observerData = null;
      if (engine && engine.observers) {
        observerData = engine.observers.get(observerKey);
      } else {
        observerData = this.observers.get(instance.id);
      }
      
      // Handle both new structure (Phase 1) and old structure
      const observer = observerData?.observer || observerData;
      
      if (!observer || !newProducts || newProducts.length === 0) return;

      // Tell the existing observer to start watching the new products
      newProducts.forEach(product => {
        product.classList.add('lumistelle-carousel--animate-in');
        observer.observe(product);
      });
    },

    // ======================================================================
    // HOVER EFFECTS
    // ======================================================================
    setupHoverEffects(instance) {
      // Event delegation is handled by the main CSS :hover pseudo-classes.
      // This JS is here in case more complex sequenced animations are needed later.
    },

    // ======================================================================
    // REDUCED MOTION ACCESSIBILITY
    // ======================================================================
    setupReducedMotion() {
      if (this.reducedMotionInitialized) return;

      const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const toggleReducedMotion = (matches) => {
        document.body.classList.toggle('lumistelle-reduced-motion', matches);
      };

      toggleReducedMotion(mediaQuery.matches);
      mediaQuery.addEventListener('change', (e) => toggleReducedMotion(e.matches));
      this.reducedMotionInitialized = true;
    }
  };

  // Export and initialize via the engine
  window.LumistelleCarouselAnimations = LumistelleCarouselAnimations;

})(window, document);